/* Simple markdown toolbar without headings - for product descriptions
   Features: Bold, italic, underline, lists, links, and basic formatting
   No heading tags allowed */


import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import {
  Bold,
  Italic,
  Underline,
  List,
  ListOrdered,
  Link,
  Code,
  Quote,
  MinusSquare,
} from 'lucide-react';

interface SimpleMarkdownToolbarProps {
  onInsert: (before: string, after?: string) => void;
}

export default function SimpleMarkdownToolbar({ onInsert }: SimpleMarkdownToolbarProps) {
  return (
    <div className="flex gap-1 flex-wrap p-3 bg-gray-50 rounded-lg border border-gray-200">
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Bold (Ctrl+B)"
        onClick={() => onInsert('**', '**')}
      >
        <Bold className="w-4 h-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Italic (Ctrl+I)"
        onClick={() => onInsert('*', '*')}
      >
        <Italic className="w-4 h-4" />
      </Button>

      <Separator orientation="vertical" className="h-8 mx-1" />

      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Bullet List"
        onClick={() => onInsert('\n- ', '')}
      >
        <List className="w-4 h-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Numbered List"
        onClick={() => onInsert('\n1. ', '')}
      >
        <ListOrdered className="w-4 h-4" />
      </Button>

      <Separator orientation="vertical" className="h-8 mx-1" />

      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Link"
        onClick={() => onInsert('[', '](https://)')}
      >
        <Link className="w-4 h-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Code"
        onClick={() => onInsert('`', '`')}
      >
        <Code className="w-4 h-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Quote"
        onClick={() => onInsert('\n> ', '')}
      >
        <Quote className="w-4 h-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        title="Horizontal Rule"
        onClick={() => onInsert('\n---\n', '')}
      >
        <MinusSquare className="w-4 h-4" />
      </Button>
    </div>
  );
}
